import { action } from 'src/redux/actions';

export const UPDATE_FILTER_QUERY_PARAMETERS = 'UPDATE_FILTER_QUERY_PARAMETERS';
export const RESET_FILTER_QUERY_PARAMETERS = 'RESET_FILTER_QUERY_PARAMETERS';

export const updateFilterQueryParameters = (params: object, isReplace: boolean, resetFilter: boolean) =>
	action(UPDATE_FILTER_QUERY_PARAMETERS, { params, isReplace, resetFilter });

export const resetFilterQueryParameters = () => action(RESET_FILTER_QUERY_PARAMETERS);
